import { Games } from "@mui/icons-material";
import { Box, Stack, ToggleButton, ToggleButtonGroup } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import { BtnSub, PlanCard, PriceTitle, SubTitle, Text } from "./styles";

function FreeCard({ onSelect, billingPeriod, handleBillingPeriodChange }) {
  
  // const { user } = useSelector((state) => state.user);

  const getPrice = () => {
    if (billingPeriod === "yearly") {
      return "Rs. 15,000"; // Change this to your yearly price
    }
    return "Rs. 1500"; // Change this to your monthly price
  };

  return (
    <PlanCard
      spacing={1.6}
      sx={{
        pb: "10px",
        // justifyContent: !user ? "space-around" : "space-between",
        justifyContent: "space-between",
      }}
    >
      <Stack spacing={1}>
        <SubTitle>
          <Games sx={{ marginRight: "4px" }} />
          Basic
        </SubTitle>
        <PriceTitle
          sx={{
            fontFamily: "sans-serif !important",
            fontSize: "2.25rem",
          }}
        >
          {getPrice()}
        </PriceTitle>
                  <Box
                    justifyContent={"center"}
                    direction="row"
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100% ",
                    }}
                  >
        <PriceTitle sx={{ color: "#A2B0B7", fontSize: "15px" }}>
        Rs. 3000 activation fee
        </PriceTitle>
         {billingPeriod === "yearly" && (
                      <Box
                        sx={{
                          backgroundColor: "#1DB45A",
                          color: "white",
                          padding: "4px 8px",
                          borderRadius: "5px",
                          width: "fit-content",
                          height: "fit-content",
                          marginInline: "10px",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                        <Text
                          sx={{
                            fontSize: "14px",
                            fontWeight: "bold",
                            color: "white",
                          }}
                          textAlign={"center"}
                        >
                          save 17%
                        </Text>
                      </Box>
                    )}
                    </Box>
      <Box sx={{ display: "flex", justifyContent: "center" }}>
          <ToggleButtonGroup
            value={billingPeriod}
            exclusive
            onChange={handleBillingPeriodChange}
            aria-label="billing period"
            sx={{
              height: "30px",
            }}
          >
            <ToggleButton
              value="monthly"
              aria-label="monthly"

            >
              Monthly
            </ToggleButton>
            <ToggleButton value="yearly" aria-label="yearly">
              Yearly
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      </Stack>


    </PlanCard>
  );
}

export default FreeCard;
